import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filename'
})
export class FilenamePipe implements PipeTransform {

  transform(filename: string): any {
   
    let url= new URL(filename)
    return url.pathname.substring(url.pathname.lastIndexOf('/')+1);
  }

}
